<template>
  <!-- 分类统计 -->
  <div>
    <div class="localQuery" :class="{ magnify: isMagnify }" v-if="authority">
      <!-- 放大缩小 -->
      <div
        class="magnify_box"
        :title="!isMagnify ? '全屏' : '退出全屏'"
        @click="switchMagnify"
      >
        <i class="iconfont icon-quanping" v-if="!isMagnify"></i>
        <i
          class="iconfont icon-suoxiaotuichuquanpingshouhui suoxiao"
          v-else
        ></i>
      </div>
      <div class="head">
        <el-form :model="form" :rules="rules" ref="form">
          <!-- 分类ID -->
          <div class="type_box time_box">
            <el-form-item class="form_item form_url" label="分类ID:">
              <div class="id_input">
                <el-input
                  v-model="form.ruleId"
                  :disabled="idDisabled"
                  placeholder="请输入分类ID"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
            <!-- 搜索按钮 -->
            <el-button
              type="primary"
              class="btn"
              @click="search"
              v-if="!conditionShow"
              >搜索</el-button
            >
          </div>
          <!-- 发表时间/入库时间 -->
          <div class="type_box time_box" v-if="conditionShow">
            <el-form-item class="form_item" label="发表时间:">
              <div class="date_box">
                <el-date-picker
                  v-model="form.date"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-form-item>
            <el-form-item
              style="margin-left: 15px;"
              class="form_item"
              label="入库时间:"
            >
              <div class="date_box">
                <el-date-picker
                  v-model="form.uDate"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  align="right"
                >
                </el-date-picker>
              </div>
            </el-form-item>
          </div>

          <!-- 来源 -->
          <div class="type_box" v-if="conditionShow">
            <el-form-item class="form_item" label="来源:">
              <div class="checkboxDom">
                <el-checkbox
                  class="checkAll"
                  :indeterminate="!fromAll"
                  v-model="fromAll"
                  @change="selectAll($event, 0)"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  v-model="form.sourceType"
                  @change="selectSomeSource($event, 0)"
                >
                  <el-checkbox
                    v-for="source in fromList"
                    :label="source.id"
                    :key="source.id"
                    >{{ source.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <!-- 记录类型 -->
          <div class="type_box" v-if="conditionShow">
            <el-form-item class="form_item" label="记录类型:">
              <div class="checkboxDom">
                <el-checkbox
                  class="checkAll"
                  :indeterminate="!recordAll"
                  v-model="recordAll"
                  @change="selectAll($event, 1)"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  v-model="form.recordType"
                  @change="selectSomeSource($event, 1)"
                >
                  <el-checkbox
                    v-for="source in recordList"
                    :label="source.id"
                    :key="source.id"
                    >{{ source.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <!-- 信源 -->
          <div class="type_box" v-if="conditionShow">
            <el-form-item class="form_item" label="信源:">
              <div class="checkboxDom">
                <el-checkbox
                  class="checkAll"
                  :indeterminate="!checkAll"
                  v-model="checkAll"
                  @change="selectAll($event, 2)"
                  >全选</el-checkbox
                >
                <el-checkbox-group
                  v-model="form.siteTypes"
                  @change="selectSomeSource($event, 2)"
                >
                  <el-checkbox
                    v-for="source in sourceList"
                    :label="source.id"
                    :key="source.id"
                    >{{ source.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </el-form-item>
          </div>
          <!-- 前十专题 -->
          <div class="type_box" v-if="conditionShow">
            <el-form-item class="form_item" label="前十专题:">
              <el-checkbox-group v-model="form.countType">
                <el-checkbox label="TopTen">获取前十个专题总量</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!-- 搜索按钮 -->
            <el-button type="primary" class="btn" @click="search"
              >搜索</el-button
            >
          </div>
        </el-form>
        <a
          href="javascript:;"
          class="show_btn"
          @click="conditionShow = !conditionShow"
        >
          {{ conditionShow ? "收起" : "展开"
          }}<i
            class="iconfont icon-xiangxiajiantouxiao"
            :class="{ icon: conditionShow }"
          ></i>
        </a>
      </div>

      <!-- 数据展示 -->
      <div class="content" ref="list" v-load="loading">
        <div v-if="listType == 'all'">
          <div
            class="content_item"
            v-for="(topic, topicIndex) in list"
            :key="topicIndex"
          >
            <div class="total">
              <span v-if="ruleName">{{ ruleName }}</span
              >总量：{{ topic.total }}
            </div>
            <ul class="list_box">
              <li v-for="(item, index) in topic.list" :key="index">
                <div class="li_head">
                  <p>
                    来源：<span>{{ fromObj[item.from] }}</span>
                  </p>
                  <p class="head_total">
                    总量：<span>{{ item.count }}</span>
                  </p>
                </div>
                <!-- 记录 -->
                <ul class="li_item">
                  <li
                    v-for="(recordVal, recordKey) in item.record_type"
                    :key="recordKey"
                  >
                    {{ recordObj[recordKey] }}： <span>{{ recordVal }}</span>
                  </li>
                </ul>
                <!-- 信源 -->
                <ul class="li_item">
                  <li
                    v-for="(siteVal, siteKey) in item.site_type"
                    :key="siteKey"
                  >
                    {{ siteObj[siteKey] || siteKey }}：<span>{{
                      siteVal
                    }}</span>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="null_data" v-if="list.length == 0">没有数据</div>
          </div>
        </div>
        <!-- 前十专题数据展示 -->
        <div v-else>
          <div
            class="content_item"
            v-for="(topic, topicIndex) in list"
            :key="topicIndex"
          >
            <div class="total">
              <span>{{ topic.list.rule_name }}</span
              >总量：{{ topic.total }}
            </div>
            <ul class="list_box">
              <li>
                <div class="head_box">
                  <div
                    class="li_head"
                    v-for="(fromVal, fromKey) in topic.list.from"
                    :key="fromKey"
                  >
                    <p>
                      来源：<span>{{ fromObj[fromKey] }}</span>
                    </p>
                    <p class="head_total">
                      总量：<span>{{ fromVal }}</span>
                    </p>
                  </div>
                </div>
                <!-- 记录 -->
                <ul class="li_item">
                  <li
                    v-for="(recordVal, recordKey) in topic.list.record_type"
                    :key="recordKey"
                  >
                    {{ recordObj[recordKey] }}： <span>{{ recordVal }}</span>
                  </li>
                </ul>
                <!-- 信源 -->
                <ul class="li_item">
                  <li
                    v-for="(siteVal, siteKey) in topic.list.site_type"
                    :key="siteKey"
                  >
                    {{ siteObj[siteKey] || siteKey }}：<span>{{
                      siteVal
                    }}</span>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="null_data" v-if="list.length == 0">没有数据</div>
          </div>
        </div>
      </div>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMagnify: false,
      loading: false,
      idDisabled: false,
      form: {
        ruleId: "",
        date: [],
        uDate: [],
        sourceType: [],
        recordType: [],
        siteTypes: [],
        countType: ["all"]
      },
      conditionShow: true,

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      siteObj: {},
      sourceList: [], // 信源类型
      checkAll: false, // 是否全选

      fromObj: {
        1: "全量库",
        2: "通用接口"
      },
      fromList: [
        // 来源
        { id: 1, name: "全量库" },
        { id: 2, name: "通用接口" }
      ],
      fromAll: false,

      recordObj: {
        normal: "正常",
        ad: "广告过滤",
        dirty: "异常数据"
      },
      recordList: [
        // 记录
        { id: "normal", name: "正常" },
        { id: "ad", name: "广告过滤" },
        { id: "dirty", name: "异常数据" }
      ],
      recordAll: false,

      list: [],
      total: 0,

      rules: {},
      ruleName: "",
      listType: "all"
    };
  },
  watch: {
    form: {
      deep: true,
      handler(e) {
        if (e.date == null) this.form.date = [];
        if (e.uDate == null) this.form.uDate = [];
        e.countType.length == 1
          ? (this.idDisabled = false)
          : (this.idDisabled = true);
      }
    }
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    }
  },
  created() {
    this.getSiteTypes();
  },
  mounted() {
    if (this.authority)
      this.$refs.list.addEventListener("scroll", this.listScroll);
  },
  activated() {
    let params = this.$store.state.topicData;
    if (params.init) {
      this.ruleName = params.ruleName;
      this.$store.state.topicData.init = false;
      let data = JSON.parse(JSON.stringify(params));
      delete data.init;
      delete data.ruleName;
      this.form = data;
      this.getData();
    }
  },
  methods: {
    // 获取列表数据
    getData() {
      this.$refs.list.scrollTop = 0;
      this.loading = true;
      let data = JSON.parse(JSON.stringify(this.form));
      // 发表时间
      if (data.date.length != 0) {
        data.startDate = data.date[0];
        data.endDate = data.date[1];
      }
      // 入库时间
      if (data.uDate.length != 0) {
        data.startDateUtime = data.uDate[0];
        data.endDateUtime = data.uDate[1];
      }

      if (this.form.countType.length == 1) {
        data.countType = "all";
      } else {
        data.countType = "TopTen";
        data.ruleId = "";
      }
      this.listType = data.countType;
      data.sourceType = data.sourceType.join(",");
      data.recordType = data.recordType.join(",");
      data.siteTypes = data.siteTypes.join(",");
      delete data.date;
      delete data.uDate;

      this.$http({
        url: this.$api.byTag,
        data
      })
        .then(res => {
          this.loading = false;
          if (res.code == 0) {
            if (data.countType == "all") {
              this.list = [res.data];
            } else {
              this.list = res.data.list;
              // if(res.data.length == 0) this.$message('没有搜索到数据哦~');
            }
            if (res.data.list.length == 0) this.$message("没有搜索到数据哦~");
          } else {
            this.list = [];
            this.$hint(res.code + "-" + res.message, "err");
          }
        })
        .catch(err => {
          this.list = [];
          this.loading = false;
        });
    },
    // 搜索
    search() {
      if (this.form.date.length == 0 && this.form.uDate.length == 0) {
        this.$hint("至少选择一个时间", "err");
        return;
      }
      if (this.form.ruleId != this.$store.state.topicData.ruleId) {
        this.ruleName = "";
      } else {
        this.ruleName = this.$store.state.topicData.ruleName;
      }
      this.getData();
    },
    // 获取所有信源
    getSiteTypes() {
      this.$http({
        url: this.$api.siteType,
        data: {}
      }).then(res => {
        if (res.code == 0) {
          this.siteObj = JSON.parse(JSON.stringify(res.data)) || {};
          this.siteObj.all = "全部";
          this.sourceList = [];
          Object.keys(res.data).forEach(key => {
            this.sourceList.push({
              id: key,
              name: res.data[key]
            });
          });
        }
      });
    },
    // 选择所有信源
    selectAll(val, type) {
      switch (type) {
        case 0:
          this.form.sourceType = [];
          if (val) {
            this.fromList.forEach(el => {
              this.form.sourceType.push(el.id);
            });
          }
          this.fromAll = val;
          break;
        case 1:
          this.form.recordType = [];
          if (val) {
            this.recordList.forEach(el => {
              this.form.recordType.push(el.id);
            });
          }
          this.recordAll = val;
          break;
        case 2:
          this.form.siteTypes = [];
          if (val) {
            this.sourceList.forEach(el => {
              this.form.siteTypes.push(el.id);
            });
          }
          this.checkAll = val;
          break;
      }
    },
    // 选择某个信源
    selectSomeSource(data, type) {
      let checkedCount = data.length;
      switch (type) {
        case 0:
          this.fromAll = checkedCount === this.fromList.length;
          break;
        case 1:
          this.recordAll = checkedCount === this.recordList.length;
          break;
        case 2:
          this.checkAll = checkedCount === this.sourceList.length;
          break;
      }
    },
    // 全屏
    switchMagnify() {
      this.isMagnify = !this.isMagnify;
    },
    // 监控列表滚动
    listScroll() {
      if (this.listType != "all") this.conditionShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.localQuery {
  width: 100%;
  height: calc(100vh - 100px);
  color: #525f7f;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  .head {
    width: 100%;
    padding: 10px 20px 5px;
    box-sizing: border-box;
    position: relative;
    border-bottom: 1px solid #e2e2e2;
    background: #f9f9f9;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    margin: 0;
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 0px;
      .date_box {
        width: 450px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        background: #fff;
      }
      .checkboxDom {
        display: flex;
      }
    }
    .input_box {
      width: 100%;
      display: flex;
      align-items: center;
      margin-top: 10px;
      .form_item {
        flex: 1;
        display: flex;
        align-items: flex-start;
        margin-right: 10px;
      }
    }
    .type_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn {
        line-height: 30px;
        padding: 0 20px;
        font-size: 13px;
      }
    }
    .time_box {
      width: 100%;
      justify-content: flex-start;
      padding-right: 100px;
      box-sizing: border-box;
      .form_url {
        width: 500px;
        .id_input {
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          background: #fff;
        }
      }
      .btn {
        margin-left: 20px;
      }
    }
    .show_btn {
      position: absolute;
      top: 0;
      right: 35px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #525f7f;
      text-decoration: none;
      .iconfont {
        font-size: 12px;
        margin-left: 5px;
        display: inline-block;
        transform: translateY(1px) rotate(0deg);
        transition: all 0.5s;
      }
      .icon {
        transform: translateY(1px) rotate(180deg);
      }
    }
  }
  .content {
    height: 0;
    flex: 1;
    padding: 20px 60px;
    margin-top: 3px;
    box-sizing: border-box;
    overflow-y: scroll;
    .content_item {
      margin-bottom: 50px;
      &:nth-last-child(1) {
        margin-bottom: 0px;
      }
      .total {
        margin: 15px 0;
        font-size: 18px;
        font-weight: bold;
        font-family: Montserrat-Bold;
        > span {
          margin-right: 20px;
        }
      }
      .list_box {
        > li {
          width: 100%;
          min-height: 100px;
          border-radius: 4px;
          padding: 10px;
          box-sizing: border-box;
          border: 1px solid #eee;
          background: #f7f7f7;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
          margin-bottom: 15px;
          .head_box {
            display: flex;
            .li_head {
              width: auto;
              margin-right: 80px;
            }
          }
          .li_head {
            width: 100%;
            margin-bottom: 15px;
            font-size: 13px;
            > p {
              > span {
                font-size: 14px;
                font-weight: bold;
              }
            }
            .head_total {
              margin-top: 10px;
            }
          }
          .li_item {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            > li {
              min-width: 160px;
              box-sizing: border-box;
              text-align: left;
              margin-right: 15px;
              margin-bottom: 15px;
              font-size: 12px;
              > span {
                font-size: 13px;
                font-weight: bold;
              }
            }
          }
        }
      }
      .null_data {
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #c0c4cc;
        border: none;
        font-size: 12px;
        &:hover {
          background: transparent;
        }
      }
    }
  }
  .magnify_box {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
    background: #525f7f;
    border-radius: 0 0 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    .suoxiao {
      transform: translateX(2px) translateY(-1px) scale(0.8);
    }
  }
}
.magnify {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100vw;
  height: 100vh;
  z-index: 99;
}

/deep/.head {
  .el-form {
    width: 100%;
  }
  .el-form-item__label {
    width: 70px;
    font-size: 12px;
    text-align: left;
  }
  .el-form-item__content {
    line-height: 30px;
    flex: 1;
  }
  .el-select {
    width: 120px;
    background: rgba(231, 235, 241, 0.6);
  }
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    border: none;
    background: transparent;
  }
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
  .el-range-separator {
    height: 30px;
  }
  .el-checkbox-group {
    height: 30px;
  }
  .el-checkbox__label {
    font-size: 12px;
  }
  .el-checkbox {
    margin-right: 10px;
  }
  .el-textarea {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/classStatistics.vue